
export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      rating: 5,
      title: 'Transformational Range',
      review: 'GreenEmbers Wholesale Nursery has a wonderful range of plants and their attention to detail and plant knowledge is exceptional. With their help we have implemented some beautiful gardens.',
      name: 'Sarah Mitchell',
      role: 'Designer',
      avatar: 'https://i.pravatar.cc/150?img=1'
    },
    {
      id: 2,
      rating: 5,
      title: 'Professional & Reliable',
      review: 'The team is incredibly professional and always on time. They maintain our commercial property beautifully, and our clients constantly compliment the landscaping.',
      name: 'Michael Govern',
      role: 'Business Owner',
      avatar: 'https://i.pravatar.cc/150?img=13'
    },
    {
      id: 3,
      rating: 5,
      title: 'Expert Plant Selection',
      review: 'Their nursery has the best selection of native plants in the area. The staff helped me choose the perfect plants for various  garden conditions. Everything is thriving!',
      name: 'Emily Rodriguez',
      role: 'Garden Consultant',
      avatar: 'https://i.pravatar.cc/150?img=5'
    },
    {
      id: 4,
      rating: 5,
      title: 'Outstanding Design Work',
      review: 'The landscape design exceeded our expectations. They created a sustainable garden that looks amazing in every season. Highly recommend their design services!',
      name: 'David Thompson',
      role: 'Property Manager',
      avatar: 'https://i.pravatar.cc/150?img=12'
    },
    {
      id: 5,
      rating: 5,
      title: 'Excellent Supply Service',
      review: 'We have been using their plant wholesale services for three years now. Our customers love the quality and range of plants we provide. They are knowledgeable, efficient, and truly care about their work.',
      name: 'Jennifer Park',
      role: 'Retail Garden Center',
      avatar: 'https://i.pravatar.cc/150?img=9'
    },
    {
      id: 6,
      rating: 5,
      title: 'Best Nursery Experience',
      review: 'From the moment we walked in, we felt welcomed. The staff is incredibly helpful and passionate about plants. We found everything we needed and more for our customer\'s garden projects.',
      name: 'Robert Williams',
      role: 'DIY Gardener',
      avatar: 'https://i.pravatar.cc/150?img=14'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-[#f8f5f0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-leaf-line text-xl text-emerald-600"></i>
          </div>
          <p className="text-emerald-700 text-sm uppercase tracking-wide font-medium">
            TESTIMONIALS
          </p>
        </div>

        <h2 className="text-5xl lg:text-6xl font-bold text-[#2d2d2d] mb-4 font-sans">
          What Our Clients Say
        </h2>
        <p className="text-lg text-gray-500 font-light mb-16">
          Real feedback from satisfied garden enthusiasts
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-lg text-amber-500"></i>
                  </div>
                ))}
              </div>

              <h3 className="text-xl font-bold text-[#2d2d2d] mb-3">
                {testimonial.title}
              </h3>

              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                {testimonial.review}
              </p>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-bold text-[#2d2d2d]">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-500">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
